import { ActionIcon, Tooltip } from '@mantine/core';
import type { Icon } from '@tabler/icons-react';
import { Link, type LinkProps } from '@tanstack/react-router';

export interface MenuLinkProps extends LinkProps, Omit<React.HTMLAttributes<HTMLAnchorElement>, 'children' | 'target'> {
  icon: Icon;
  title: string;
}

export function MenuLink({ to, icon: IconComponent, title, ...linkProps }: MenuLinkProps) {
  return (
    <Link preload="intent" {...linkProps} to={to} activeOptions={{ includeSearch: false }}>
      {({ isActive }) => {
        if (isActive) {
          return (
            <Tooltip label={title} position="right" withArrow>
              <ActionIcon size="xl" variant="white">
                <IconComponent stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          );
        }
        return (
          <Tooltip label={title} position="right" withArrow>
            <ActionIcon color="white" size="xl" variant="transparent">
              <IconComponent stroke={1} />
            </ActionIcon>
          </Tooltip>
        );
      }}
    </Link>
  );
}
